import React, {ReactNode, Component} from "react"
import styled from "styled-components"

import theme from "@irati/ui/src/global/theme"
import Card from "@irati/ui/src/Layout/Card"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {Body, H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import EnabledDisabledLabel, {TooltipLabel} from "./EnabledDisabledLabel"

const FlexItem = styled.div`
  flex-grow: 1;
  width: 33%;
  ${theme.mediaQueries.maxWidthMedia.desktop`
    width: unset;
    flex-grow: unset;
  `}
`

interface Props {
  enabled: boolean
  title: string
  text: string
  logos: any[]
  children?: ReactNode
  purchased?: boolean
  textValues?: object
  tooltipLabel?: TooltipLabel
  load?: Promise<any> | null
  onClick: () => void
}

class IntegrationCard extends Component<Props> {
  render() {
    const {enabled, children, purchased, title, text, textValues, tooltipLabel, logos, load, onClick} = this.props
    return (
      <Card>
        <Flex alignItems="center" marginBottom={2}>
          <H3 marginRight={theme.spacing.oneAndHalf} marginBottom={1} marginTop color={theme.colors.greys.black}>
            <FormattedMessage id={title} />
          </H3>
          <EnabledDisabledLabel enabled={enabled} purchased={purchased} tooltip={tooltipLabel} />
        </Flex>
        {children}
        <Body small color={theme.colors.greys.black} marginBottom={2}>
          <FormattedMessage id={text} values={textValues} />
        </Body>
        {logos.length > 0 && (
          <Flex justifyContent="flex-start" wrap="wrap" gap="10px 0px">
            {logos.map((item, k) => (
              <FlexItem key={k}>{React.cloneElement(item)}</FlexItem>
            ))}
          </Flex>
        )}
        <Button id="settingsIntegrationLearnMore_button" primary marginTop={2} onClick={onClick} load={load}>
          <FormattedMessage id="admin.containers.integrations.startIntegration.button" />
        </Button>
      </Card>
    )
  }
}

export default IntegrationCard
